import { render, staticRenderFns } from "./BaseTextButton.vue?vue&type=template&id=de390d3e&scoped=true"
import script from "./BaseTextButton.vue?vue&type=script&lang=js"
export * from "./BaseTextButton.vue?vue&type=script&lang=js"
import style0 from "./BaseTextButton.vue?vue&type=style&index=0&id=de390d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de390d3e",
  null
  
)

export default component.exports